import * as React from "react";
import {
  styledAccordian,
  styledListGroups,
  questionLabel,
  card,
} from "./FrequentlyAskedQuestions.module.scss";
import Tab from "react-bootstrap/Tab";
import Card from "react-bootstrap/Card";
import Accordion from "react-bootstrap/Accordion";
import AccordionContext from "react-bootstrap/AccordionContext";
import ListGroup from "react-bootstrap/ListGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAccordionToggle } from "react-bootstrap";
import { useLocation } from "@reach/router";

export const StyledListGroup: React.FC<any> = (props) => {
  return <ListGroup className={styledListGroups}>{props.children}</ListGroup>;
};

const QuestionLabel: React.FC<any> = React.forwardRef<HTMLInputElement, any>(
  (props, ref) => {
    return props.isSupportPage ? (
      <a id={props.id} ref={ref} className={questionLabel} {...props}>
        {props.children}
      </a>
    ) : (
      <h3 id={props.id} style={{ margin: "0px" }}>
        <a ref={ref} className={questionLabel} {...props}>
          {props.children}
        </a>
      </h3>
    );
  }
);
QuestionLabel.displayName = "QuestionLabel"; // this line to set the display name
export const StyledAccordion: React.FC<any> = (props) => {
  return (
    <Accordion className={styledAccordian} {...props}>
      {props.children}
    </Accordion>
  );
};

export const ContextAwareToggle: React.FC<any> = (props) => {
  const currentEventKey = React.useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(props.eventKey, () => {
    props.callback && props.callback(props.eventKey);
  });
  const isCurrentEventKey = currentEventKey === props.eventKey;
  return (
    <Card.Header
      onClick={decoratedOnClick}
      className="py-3 pl-0 pr-3 border-bottom-0 bg-light"
      style={{ display: "flex", justifyContent: "space-between" }}
    >
      {props.children}
      {isCurrentEventKey ? (
        <FontAwesomeIcon icon="chevron-up" />
      ) : (
        <FontAwesomeIcon icon="chevron-down" />
      )}
    </Card.Header>
  );
};

export const QuestionCard: React.FC<any> = (props) => {
  const { ques, onQuesToggle, ifSetFocus } = props;
  const quesRef = React.useRef(ques?.question);
  const location = useLocation();
  React.useEffect(() => {
    ifSetFocus &&
      quesRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
  }, [ifSetFocus]);

  return (
    <Card className={card}>
      <ContextAwareToggle
        eventKey={ques?.question}
        callback={(key: any) => {
          onQuesToggle(key);
          quesRef.current.focus();
        }}
      >
        <QuestionLabel
          ref={quesRef}
          aria-label={ques?.question}
          aria-expanded={ifSetFocus}
          quesIndex={props?.quesIndex}
          isSupportPage={
            location && location.pathname.indexOf("/support") != -1
          }
          id={`question-label-${props.secIndex}-${props.quesIndex}`}
        >
          {ques?.question}
        </QuestionLabel>
      </ContextAwareToggle>
      <Accordion.Collapse eventKey={ques?.question}>
        <Card.Body
          id={`question-answer-${props.secIndex}-${props.quesIndex}`}
          dangerouslySetInnerHTML={{ __html: ques?.answer.processed }}
        ></Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};

export const QuestionsTab: React.FC<any> = (props) => {
  const { section, questions, className, activeQuesKey } = props;
  const pf = props.preFixer || "d";
  const formattedTitle = section.field_title.replaceAll(" ", "");
  return (
    <Tab.Content className={className}>
      <Tab.Pane
        eventKey={`${formattedTitle}`}
        id={`support-faq-tabpane-${section.field_title}`}
        aria-labelledby={`support-faq-tab-${section.field_title}`}
      >
        <StyledAccordion
          activeKey={activeQuesKey}
          id={`support-faq-tab-${formattedTitle}`}
        >
          {questions.map((ques: any, quesIndex: number) => {
            return (
              <QuestionCard
                key={`${pf}-q-${section.field_title}${quesIndex}`}
                ques={ques}
                index={quesIndex}
                onQuesToggle={props.onQuesToggle}
                ifSetFocus={activeQuesKey == ques?.question}
                secIndex={props.id}
                quesIndex={quesIndex + 1}
              />
            );
          })}
        </StyledAccordion>
      </Tab.Pane>
    </Tab.Content>
  );
};
